import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { Row, Group, FieldInput } from '@/components/form'
import Icon from '@/components/icon'
import useMediaQuery from '@/hooks/use-media-query'
import { breakpoints, fontSizes } from '@/styles'
import AreaTitle from '@/components/area-title'
import { StyledPanel } from './elements'
import CreditCardInput from './credit-card-input'

const AssuranceText = styled.p`
  display: flex;
  align-items: center;
  font-size: ${fontSizes.small};
  letter-spacing: -0.08px;
  line-height: 18px;
  margin: 20px 0 0;

  svg {
    margin-right: 5px;
    flex-shrink: 0;
  }

  @media screen and (max-width: ${breakpoints.ipadMiniMax}) {
    margin: 20px 10px 0;
  }
`

const CardDetailsForm = ({
  autocompletePrefix = 'billing',
  values,
  allowUnionPayOnStripe = false,
  setCardInfoValid,
  setCardMethodValid
}) => {
  const { t } = useTranslation()
  const displayMobile = useMediaQuery(`(max-width: ${breakpoints.ipadMiniMax})`)
  const colSize = displayMobile ? 12 : 6

  const acceptedCards =
    values.payment_method === 'stripe' && !allowUnionPayOnStripe
      ? ['visa', 'mastercard', 'american-express']
      : ['unionpay', 'visa', 'mastercard', 'american-express']

  const cardMethodErrors = {
    stripe_upop: t(
      'r.payment.edit.unknown_card.error',
      '** The credit card you have entered is not accepted. please try again with a different card.'
    ),
    stripe: t(
      'r.payment.edit.visa_mastercard_american_express_card.error',
      '** The credit card you have entered is not accepted. Please try again by using a Mastercard, Visa, or American Express.'
    ),
    upop: t(
      'r.payment.edit.unionpay_card.error',
      '** The credit card you have entered is not accepted. Please try again by using a UnionPay card.'
    )
  }

  return (
    <>
      <AreaTitle>{t('r.payment.edit.card_details.subtitle', 'Card Details')}</AreaTitle>
      <StyledPanel hSpace={32} vSpace={32}>
        <Row>
          <Group col={colSize}>
            <FieldInput
              id="first_name"
              name="first_name"
              autoComplete={`${autocompletePrefix} cc-given-name`}
              placeholder={t('r.payment.edit.make_payment_first_name.label', 'First name')}
              required
            />
          </Group>
          <Group col={colSize}>
            <FieldInput
              id="last_name"
              name="last_name"
              autoComplete={`${autocompletePrefix} cc-family-name`}
              placeholder={t('r.payment.edit.make_payment_last_name.label', 'Last name')}
              required
            />
          </Group>
        </Row>
        <CreditCardInput
          autocompletePrefix={autocompletePrefix}
          values={values}
          setCardInfoValid={setCardInfoValid}
          setCardMethodValid={setCardMethodValid}
          cardMethods={{
            acceptedCards,
            error:
              cardMethodErrors[
                values.payment_method !== 'stripe' || !allowUnionPayOnStripe
                  ? values.payment_method
                  : 'stripe_upop'
              ]
          }}
        />
        <AssuranceText>
          <Icon id="secure" height={24} width={24} />
          {t(
            'l.payment_settings.edit.safe_data_transaction.text',
            'Your transaction will be paid through a secure encrypted network and your information will never be shared with anyone.'
          )}
        </AssuranceText>
      </StyledPanel>
    </>
  )
}

export default CardDetailsForm
